import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  rightArrow,
  rightArrowHover,
} from '../../../assets/images';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const ServicesDetailItems = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const { id } = useParams();

  const [singleNews, setSingleNews] = useState(null);
  const [services, setServices] = useState([]);

  const getLocalizedField = (item, fieldBase) => {
    if (!item) return '';
    if (currentLanguage === 'en') return item[`${fieldBase}En`] || item[fieldBase] || '';
    if (currentLanguage === 'ru') return item[`${fieldBase}Ru`] || item[fieldBase] || '';
    return item[fieldBase] || ''; // default: az
  };

  useEffect(() => { 
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get('https://cortex-site.runasp.net/api/Services');
      setServices(response.data);
      const filteredService = response.data.find((product) => product.id == id);
      setSingleNews(filteredService);
    } catch (error) {
      console.error('Error fetching services:', error);
    }
  };

  return (
    <div className='pt-[88px] md:pt-[104px] bg-[#F9F9F9]'>
      <div className='max-w-containerSm md:max-w-container mx-auto'>
        <div
          className='text-[#1C1C1C]'
          dangerouslySetInnerHTML={{
            __html: getLocalizedField(singleNews, 'description'),
          }}
        ></div>

        <div className='flex justify-between items-center mt-[72px]'>
          <p className='text-[#1C1C1C] font-medium text-[24px] mx-auto md:mx-0'>
            {t('Digər xidmətlər')}
          </p>
          <a className='hidden md:block group' href={`/${currentLanguage}/services`}>
            <div className='flex justify-between items-center w-[144px] rounded-[12px] bg-[#FBFBFB] text-[#1C1C1C] h-[46px]'>
              <p className='transition-colors duration-300 group-hover:text-[#2a3d63]'>
                {t('Hamısına bax')}
              </p>
              <img className='w-2 transition-opacity duration-300 group-hover:hidden' src={rightArrow} alt='' />
              <img className='w-2 transition-opacity duration-300 hidden group-hover:block' src={rightArrowHover} alt='' />
            </div>
          </a>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-3 gap-5 mt-[32px]'>
          {services.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className='w-full border border-[#E5E5E5] rounded-lg hover:border-[#2a3d63] transition-all duration-300'
            >
              <img src={`https://cortex-site.runasp.net/${item.image}`} className='w-full' alt='' />
              <div className='bg-white py-4 pl-4 rounded-lg'>
                <p className='text-[#1C1C1C] text-[20px] font-medium'>
                  {getLocalizedField(item, 'title')}
                </p>
                <p className='mt-4 text-[#1C1C1C]'>
                  {getLocalizedField(item, 'description').replace(/<[^>]*>/g, '').slice(0, 80)}...
                </p>
                <a className='group' href={`/${currentLanguage}/services/${item?.id}`}>
                  <div className='flex items-center mt-4 justify-between mx-auto md:mx-0 w-[100px] rounded-[12px] bg-white text-[#1C1C1C] h-[46px]'>
                    <p className='transition-colors duration-300 group-hover:text-[#2a3d63]'>
                      {t('Ətraflı')}
                    </p>
                    <img className='w-2 group-hover:hidden' src={rightArrow} alt='' />
                    <img className='w-2 hidden group-hover:block' src={rightArrowHover} alt='' />
                  </div>
                </a>
              </div>
            </div>
          ))}

          <a className='block md:hidden' href={`/${currentLanguage}/services`}>
            <div className='flex justify-between items-center mx-auto w-[144px] rounded-[12px] bg-[#FBFBFB] text-[#1C1C1C] h-[46px]'>
              <p>{t('Hamısına bax')}</p>
              <img className='w-2' src={rightArrow} alt='' />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ServicesDetailItems;
